import React from 'react'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { ErrorBoundary } from '@appsignal/react'

import Routes from './components/Routes'
import createStore from './store'
import OAuthIframe from './containers/OAuthCallback/OAuthIframe'
import { appsignal } from './resources/appsignal'

const { store, persistor } = createStore()

const App = () => {
  return (
    <ErrorBoundary instance={appsignal}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <OAuthIframe />
          <Routes />
        </PersistGate>
      </Provider>
    </ErrorBoundary>
  )
}

export default App
